import _ from 'lodash';
import { SPECIES_ALIASES } from 'app/constants/species';

import enTranslationMessages from './translations/en.json';
import frTranslationMessages from './translations/fr.json';
import deTranslationMessages from './translations/de.json';
import srTranslationMessages from './translations/sr.json';
import elTranslationMessages from './translations/el.json';
import nlTranslationMessages from './translations/nl.json';
import nbTranslationMessages from './translations/nb.json';
import ruTranslationMessages from './translations/ru.json';
import ukTranslationMessages from './translations/uk.json';
import itTranslationMessages from './translations/it.json';
import fiTranslationMessages from './translations/fi.json';
import ptTranslationMessages from './translations/pt.json';
import skTranslationMessages from './translations/sk.json';
import esTranslationMessages from './translations/es.json';
import czTranslationMessages from './translations/cs.json'; // Google use cs to identify Czech language
import koTranslationMessages from './translations/ko.json';
import svTranslationMessages from './translations/sv.json';

const translationMessages = {
  en: enTranslationMessages,
  fr: frTranslationMessages,
  de: deTranslationMessages,
  sr: srTranslationMessages,
  el: elTranslationMessages,
  nl: nlTranslationMessages,
  nb: nbTranslationMessages,
  ru: ruTranslationMessages,
  uk: ukTranslationMessages,
  it: itTranslationMessages,
  fi: fiTranslationMessages,
  pt: ptTranslationMessages,
  sk: skTranslationMessages,
  es: esTranslationMessages,
  cz: czTranslationMessages,
  ko: koTranslationMessages,
  sv: svTranslationMessages,
};

_.forEach(SPECIES_ALIASES, (aliases, specie) => {
  const specieTranslations = _.map(
    translationMessages,
    (translationDict) => translationDict[`patient_info.specie.${specie}`]
  );
  aliases.push(...specieTranslations);
});
Object.freeze(translationMessages);

export default translationMessages;
